webpackJsonp([7],{

/***/ "AefF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"block image stacked-column",class:'column-' + _vm.$getField('tall_alignment', _vm.data)},[_c('div',{staticClass:"tall bg-parent",class:{ 'has-padding' : _vm.$getField('tall_padding', _vm.data) },style:({ backgroundColor: _vm.$getField('tall_colour', _vm.data)})},[_c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:('https://api.alt-design.net/api/image/' + _vm.$getField('tall_image', _vm.data)),expression:"'https://api.alt-design.net/api/image/' + $getField('tall_image', data)",arg:"background-image"}],staticClass:"bg-fade"})]),_vm._v(" "),_c('div',{staticClass:"split"},[_c('div',{staticClass:"top bg-parent"},[_c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:('https://api.alt-design.net/api/image/' + _vm.$getField('top_image', _vm.data)),expression:"'https://api.alt-design.net/api/image/' + $getField('top_image', data)",arg:"background-image"}],staticClass:"bg-fade"})]),_vm._v(" "),_c('div',{staticClass:"bottom bg-parent"},[_c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:('https://api.alt-design.net/api/image/' + _vm.$getField('bottom_image', _vm.data)),expression:"'https://api.alt-design.net/api/image/' + $getField('bottom_image', data)",arg:"background-image"}],staticClass:"bg-fade"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I7Kb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StackedColumn_vue__ = __webpack_require__("WkhI");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_043369f7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StackedColumn_vue__ = __webpack_require__("AefF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StackedColumn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_043369f7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StackedColumn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "WkhI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    data: [Array, Object]
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/7.10ef0a8467f25866f7f8.js